import React from 'react';

interface FooterProps {
  variant?: 'standard' | 'minimal' | 'signature';
  notes?: string;
}

export default function Footer({ variant = 'standard', notes }: FooterProps) {
  if (variant === 'minimal') {
    return (
      <div className="mt-6 pt-4 border-t text-center text-xs text-gray-600">
        <p>Thank you for your business!</p>
      </div>
    );
  }

  if (variant === 'signature') {
    return (
      <div className="mt-8">
        {notes && (
          <div className="mb-6">
            <p className="text-sm font-semibold mb-1">Notes:</p>
            <p className="text-sm text-gray-600">{notes}</p>
          </div>
        )}
        <div className="flex justify-between items-end mt-12">
          <div className="text-center">
            <div className="border-t border-gray-400 w-48 mb-1"></div>
            <p className="text-sm">Patient Signature</p>
          </div>
          <div className="text-center">
            <div className="border-t border-gray-400 w-48 mb-1"></div>
            <p className="text-sm">Authorized Signature</p>
          </div>
        </div>
        <div className="mt-6 pt-4 border-t text-center text-xs text-gray-600">
          <p>This is a computer-generated invoice and does not require a physical signature.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="mt-8">
      {notes && (
        <div className="mb-6 p-4 bg-gray-50 rounded">
          <p className="text-sm font-semibold mb-2">Notes:</p>
          <p className="text-sm text-gray-600">{notes}</p>
        </div>
      )}
      <div className="flex justify-between items-end mt-12">
        <div className="text-center">
          <div className="border-t-2 border-gray-400 w-48 mb-2"></div>
          <p className="text-sm font-medium">Patient Signature</p>
          <p className="text-xs text-gray-500">Date: _______________</p>
        </div>
        <div className="text-center">
          <div className="border-t-2 border-gray-400 w-48 mb-2"></div>
          <p className="text-sm font-medium">Authorized Signature</p>
          <p className="text-xs text-gray-500">Date: _______________</p>
        </div>
      </div>
      <div className="mt-8 pt-4 border-t-2 border-gray-300 text-center text-sm text-gray-600">
        <p className="font-medium mb-1">Thank you for choosing our services!</p>
        <p className="text-xs">This is a computer-generated invoice and does not require a physical signature.</p>
      </div>
    </div>
  );
}
